<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>
                Détail d'un concert
            </h1>
            <ol class="breadcrumb">
                <li><router-link :to="{ name: 'dashboard' }"><i class="fa fa-music"> Gestion des concerts</i></router-link></li>
                <li class="active">Détail</li>
            </ol>
        </section>

        <!-- Main content -->
        <section class="content">
            <header>
                <router-link class="btn btn-primary" :to="{ name : 'concerts.edit', params: { id: $route.params.id }}">
                    <i class="fa fa-plus"></i> Editer le concert
                </router-link>
            </header>

            <!-- Default box -->
            <div class="box">
                <div class="box-header with-border">
                    <h3 class="box-title">Concert N° {{ $route.params.id }}</h3>
                </div>
                <div class="box-body">
                    <section id="event">
                        <header>
                            <h4>Informations générales du concert</h4>
                        </header>
                        <ul>
                            <li>Concert : {{ concert.name }}</li>
                            <li>Organisateur : {{ concert.organizer}}</li>
                            <li>Date : {{ concert.event_day }}</li>
                        </ul>
                    </section>
                    <section id="stats">
                        <header>
                            <h4>Statistiques</h4>
                        </header>
                        <ul>
                            <li>CA réalisé : {{ turnover.total }}€</li>
                            <li>
                                Places vendues : {{turnover.sumTickets }}
                                <a title="Voir le détail" href="#" v-on:click.prevent="dom.dropdown.sold = !dom.dropdown.sold"><i class="fa fa-plus"></i></a>
                                <ul v-show="dom.dropdown.sold">
                                    <li v-for="ticket in tickets">Tarif {{ ticket.name }} : {{ ticket.totalTickets }}</li>
                                </ul>
                            </li>
                            <li>Places restantes : {{ stockTotal }}
                                <a title="Voir le détail" href="#" v-on:click.prevent="dom.dropdown.stock = !dom.dropdown.stock"><i class="fa fa-plus"></i></a>
                                <ul v-show="dom.dropdown.stock">
                                    <li v-for="ticket in tickets">Tarif {{ ticket.name }} : {{ ticket.stock }}</li>
                                </ul>
                            </li>
                        </ul>
                    </section>
                    <section id="orders">
                        <header>
                            <h4>Liste des commandes</h4>
                        </header>
                        <table class="table table-responsive">
                            <thead>
                            <tr>
                                <th>Date</th>
                                <th>Numéro commande</th>
                                <th>Nom du client</th>
                                <th>Prénom du client</th>
                                <th>Quantité prix normal</th>
                                <th>Quantité prix réduit</th>
                                <th>Quantité prix groupe</th>
                                <th>Mode d'envoi</th>
                                <th>Total commande</th>
                                <th>Numéro paiement</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr v-for="order in orders">
                                    <td>{{ order.created_at }}</td>
                                    <td>{{ order.order_id }}</td>
                                    <td>{{ order.lastname }}</td>
                                    <td>{{ order.firstname }}</td>
                                    <td>{{ order.quantity_normal == null ? 0 : order.quantity_normal }}</td>
                                    <td>{{ order.quantity_reduced == null ? 0 : order.quantity_reduced }}</td>
                                    <td>{{ order.quantity_group == null ? 0 : order.quantity_group }}</td>
                                    <td>{{ order.type }}</td>
                                    <td>{{ order.total }}</td>
                                    <td>{{ order.payment_id}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </section>
                </div>
                <!-- /.box-body -->
                <div class="box-footer">
                    <router-link class="btn btn-default" :to="{ name: 'dashboard' }">
                        Retour à la liste
                    </router-link>
                    <button v-on:click.prevent="print" class="btn btn-primary">Imprimer</button>
                    <button v-on:click.prevent="exportToCsv" class="btn btn-primary">Exporter</button>
                </div>
                <!-- /.box-footer-->
            </div>
            <!-- /.box -->

        </section>
        <!-- /.content -->
    </div>
</template>

<script>
  import pdfMake from 'pdfmake/build/pdfmake'
  import pdfFonts from 'pdfmake/build/vfs_fonts'

  export default {
    name: 'DashboardShow',
    data: function () {
      return {
        concert: {},
        orders: [],
        turnover: {},
        tickets: [],
        dom: {
          dropdown: {
            stock: false,
            sold: false
          }
        }
      }
    },
    created: function () {
      let id = this.$route.params.id
      this.$http.get('http://ws.ojssymphonique.net/api/concerts/' + id + '?token=' + localStorage.getItem('token')).then(function (data) {
        this.concert = data.body.concert
        this.orders = data.body.orders
        this.turnover = data.body.turnover[0]
        this.tickets = data.body.tickets

        // this.exportToCsv()
      })
    },
    computed: {
      stockTotal: function () {
        let stock = 0
        for (let ticket of this.tickets) {
          stock += parseInt(ticket.stock)
        }

        return stock
      }
    },
    methods: {
      print: function () {
        pdfMake.vfs = pdfFonts.pdfMake.vfs

        let ticketsSold = []
        let ticketsLeft = []
        for (let ticket of this.tickets) {
          ticketsSold.push(ticket.totalTickets + ' au tarif ' + ticket.name)
          ticketsLeft.push(ticket.stock + ' au tarif ' + ticket.name)
        }

        var docDefinition = {
          content: [{
            text: 'Détail du concert N°' + this.concert.id,
            style: 'header',
            fontSize: 25
          }, {
            ul: [
              'Concert : ' + this.concert.name,
              'Organisateur : ' + this.concert.organizer,
              'Date : ' + this.concert.event_day,
              'CA réalisé : ' + this.turnover.total,
              [
                'Places restantes : ' + this.stockTotal, {
                  ul: ticketsLeft
                }
              ],
              [
                'Places vendues : ' + this.turnover.sumTickets, {
                  ul: ticketsSold
                }
              ]
            ],
            margin: [0, 20]
          }, {
            style: 'tableExample',
            table: {
              headerRows: 1,
              body: [
                [
                  {text: 'Date', style: 'tableHeader'},
                  {text: 'N° commande', style: 'tableHeader'},
                  {text: 'Client', style: 'tableHeader'},
                  {text: 'Quantités (normal, réduit, groupe)', style: 'tableHeader', colSpan: 3},
                  {text: 'Prix normal', style: 'tableHeader'},
                  {text: 'Prix groupe', style: 'tableHeader'},
                  {text: 'Envoi', style: 'tableHeader'},
                  {text: 'Total', style: 'tableHeader'},
                  {text: 'N° paiement', style: 'tableHeader'}
                ]
              ]
            }
          }]
        }
        for (let order of this.orders) {
          let date = new Date(order.created_at)
          docDefinition.content[2].table.body.push([
            date.toLocaleDateString() + ' ' + date.toLocaleTimeString(),
            order.order_id,
            order.firstname + ' ' + order.lastname,
            order.quantity_normal ? order.quantity_normal : 0,
            order.quantity_reduced ? order.quantity_reduced : 0,
            order.quantity_group ? order.quantity_group : 0,
            order.type,
            order.total,
            order.payment_id
          ])
        }
        pdfMake.createPdf(docDefinition).download()
      },
      exportToCsv: function () {
        let json2csv = require('json2csv')
        let fieldNames = ['Date', 'Numéro commande', 'Nom du client', 'Prénom du client', 'Quantité prix normal', 'Quantité prix réduit', 'Quantité prix groupe', 'Mode d\'envoi', 'Total commande', 'Numéro paiement']
        let fields = ['created_at', 'order_id', 'lastname', 'firstname', 'quantity_normal', 'quantity_reduced', 'quantity_group', 'type', 'total', 'payment_id']

        try {
          let result = json2csv({ data: this.orders, fields: fields, fieldNames: fieldNames })
          if (!result.match(/^data:text\/csv/i)) {
            result = 'data:text/csv;charset=utf-8,' + result
          }
          let data = encodeURI(result)

          let link = document.createElement('a')
//          link.setAttribute('href', data)
//          link.setAttribute('download', 'export.csv')
          link.download = 'export.csv'
          link.href = data
          link.click()
          $(link).trigger('click')
//          link.textContent = 'Exporter en CSV'
//          link.classList.add('btn')
//          link.classList.add('btn-primary')
//          document.querySelector('.box-footer').appendChild(link)
        } catch (err) {
          // console.error(err)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Show.vue?7c9a13bf